import { useMemo, type ReactElement } from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi } from '@/hooks';
import { sidebarItems } from './sidebar';
import type { PaginaData } from '@/interfaces/strapi';
import { getPage } from '@/services/strapi';
import { ROUTES } from '@/constants';
import { SectionTitle } from '@/components';

export const AcademiaOpositores = (): ReactElement => {
	const {
		loading: loadingPage,
		data: page,
		error: errorPage,
	} = useStrapiApi<PaginaData | null, string>(getPage, {
		autoFetch: true,
		params: 'academia-de-opositores',
	});

	usePageBreadcrumb([
		{ label: 'Información', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
		{ label: page?.title ?? '' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	if (loadingPage) return <div className="u-mt-md">Cargando…</div>;
	if (errorPage) return <div className="u-mt-md">No se pudo cargar la página.</div>;
	if (!page) return <div className="u-mt-md">No se encontró la página.</div>;

	return (
		<div>
			<SectionTitle title={page.title} tag="h1" align="left" className="u-mb-16" />
			<div className="o-strapi-page">{page.body && <BlocksRenderer content={page.body as any} />}</div>
		</div>
	);
};
